export default __webpack_public_path__ + "static/media/email.907829ae.svg";